//all functions for home.
import './index';
import './components/logged_in_notify';



// WEBPACK FOOTER //
// ./app/javascript/layout/registration.jsx